<script lang="ts">
  import { defineComponent } from 'vue';

  export default defineComponent({
    props: {
      height: { type: Number, default: 104 },
      width: { type: Number, default: 104 },
    },
  });
</script>

<template>
  <svg
    :height="height"
    :width="width"
    class="heart-stroke-animated"
    fill="none"
    viewBox="0 0 33 28"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      class="heart-stroke-path"
      d="M1.80106 3.3184C0.721009 4.07827 0.078125 5.31758 0.078125 6.63978V15.0852C0.078125 16.938 1.00848 18.6666 2.55369 19.6847L12.4263 26.1895C13.7773 27.0796 15.5273 27.0796 16.8783 26.1895L26.7509 19.6847C28.2961 18.6666 29.2264 16.938 29.2264 15.0852V6.63979C29.2264 5.31758 28.5835 4.07827 27.5035 3.3184L24.9756 1.53992C23.4612 0.474504 21.4188 0.572544 20.013 1.77813L17.2867 4.11622C15.7703 5.41672 13.5343 5.41672 12.0178 4.11622L9.29154 1.77812C7.88579 0.572543 5.8433 0.474505 4.32895 1.53992L1.80106 3.3184Z"
      transform="translate(2,2)"
    />
  </svg>
</template>

<style lang="scss">
  .heart-stroke-animated {
    .heart-stroke-path {
      stroke: #0890f1;
      stroke-width: 2;
      /* This must be this exact value, it's the length of the path */
      stroke-dasharray: 93.71533203125;
      stroke-dashoffset: 93.71533203125;
      stroke-linecap: round;

      animation: stroke-travel 1350ms infinite;
      animation-timing-function: ease;
    }

    @keyframes stroke-travel {
      0% {
        stroke-dashoffset: 93.71533203125;
      }

      50% {
        stroke-dashoffset: 2 * 93.71533203125;
      }

      100% {
        stroke-dashoffset: 3 * 93.71533203125;
      }
    }
  }
</style>
